import React, { useEffect, useState } from "react";
import style from "./style.module.css";

const FormPersonalTrainer=(props)=>{
    const [namaPeserta,setNamaPeserta]=useState("");
    const [alamat,setAlamat]=useState("");
    const [nomorHp,setNomorHp]=useState("");
    const [beratBadan,setBeratBadan]=useState("");
    const [goal,setGoal]=useState("");
    const [paketPertemuan,setPaketPertemuan]=useState("");
    const [statusPertemuan,setStatusPertemuan]=useState("");
    const [dataNamaTrainer,setDataNamaTrainer]=useState([]);
    const [trainer,setTrainer]=useState("");
    const [pembayaran,setPembayaran]=useState("");
    const [keteranganKirim,setKeteranganKirim]=useState("");
    const url =props.url;
    // function ambil nama trainer
    // function ambil nama trainer dan user aktifnya
  const GetNamaTrainer = async () => {
    const response = await fetch(`${url}/?op=getNamaTrainer`);
    const data = await response.json();
    if (data !== null) {
      setDataNamaTrainer(data);
    } else {
  setDataNamaTrainer([]);
    }
  };
  // function klik Kirim
  const KlikKirim=()=>{
    if(namaPeserta===""||alamat===""||nomorHp===""||beratBadan===""||goal===""||trainer==="Pilih"||trainer===""||paketPertemuan==="Pilih"||paketPertemuan===""||
        statusPertemuan==="Pilih"||statusPertemuan===""||pembayaran==="Pilih"||pembayaran===""
    ){
setKeteranganKirim("Data diisi lengkap");
    }
    else{
        setKeteranganKirim("");
fetch(url + "/?op=inputPersonalTrainerNew", {
      method: "post",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: "nama_trainer=" + trainer+
      "&nama_peserta="+namaPeserta+
      "&alamat="+alamat+
      "&nomor_hp="+nomorHp+
      "&berat_badan="+beratBadan+
      "&goal="+goal+
      "&paket_pertemuan="+paketPertemuan+
      "&status_pertemuan="+statusPertemuan+
      "&metode="+pembayaran
    })
    .then((response) => response.json())
    .then((json)=>{
        if(json==="Berhasil"){
setTrainer("");
setNamaPeserta("");
setAlamat("");
setNomorHp("");
setBeratBadan("");
setGoal("");
setPaketPertemuan("");
setStatusPertemuan("");
setPembayaran("");
setKeteranganKirim("Data berhasil terkirim");
props.Terkirim("Terkirim");
setTimeout(() => {
    setKeteranganKirim("");
  }, 3000);
        }else{

        }
    })
    }
   
  }
  //useEffect get nama trainer
  useEffect(()=>{
GetNamaTrainer();
  },[])
    return(
        <div className={style.containerAll}>
<div className={style.containerForm}>
<div className={style.judulForm}>
Form Personal Trainer
</div>
<div className={style.containerIsi}>
<div className={style.divInputan}>
    <div>
Nama Peserta
    </div>
    <input onChange={(e)=>setNamaPeserta(e.target.value)} value={namaPeserta}/>
</div>
<div className={style.divInputan}>
    <div>
Alamat
    </div>
    <input onChange={(e)=>setAlamat(e.target.value)} value={alamat}/>
</div>
<div className={style.divInputan}>
    <div>
Nomor Hp
    </div>
    <input onChange={(e)=>setNomorHp(e.target.value)} type="number" value={nomorHp}/>
</div>
<div className={style.divInputan}>
    <div>
Berat Badan
    </div>
    <input onChange={(e)=>setBeratBadan(e.target.value)} type="number" value={beratBadan}/>
</div>
<div className={style.divInputan}>
    <div>
Goal
    </div>
    <input onChange={(e)=>setGoal(e.target.value)} type="number" value={goal}/>
</div>
<div className={style.divInputan}>
    <div>
Paket Pertemuan
    </div>
    <input type="number" disabled={true}/>
    <select value={paketPertemuan} onChange={(e)=>{
        setPaketPertemuan(e.target.value)
    }}>
        <option value="Pilih">
            Pilih
        </option>
        <option value="4">
            4 x Meeting
        </option>
        <option value="10">
            10 x Meeting
        </option>
         <option value="15">
            15 x Meeting
        </option>
         <option value="20">
            20 x Meeting
        </option>
         <option value="25">
            25 x Meeting
        </option>
    </select>
</div>
<div className={style.divInputan}>
    <div>
Status Pertemuan
    </div>
    <input type="number" disabled={true}/>
    <select value={statusPertemuan} onChange={(e)=>{
        setStatusPertemuan(e.target.value)
    }}>
        <option value="Pilih">
            Pilih
        </option>
        <option value="One-on-One Session">
         One-on-One Session
        </option>
        <option value="Buddy / Couple Training">
            Buddy / Couple Training
        </option>
       
    </select>
</div>
<div className={style.divInputan}>
    <div>
Trainer
    </div>
    <input type="number" disabled={true}/>
    <select value={trainer} onChange={(e)=>{
        setTrainer(e.target.value)
    }}>
        <option value="Pilih">
            Pilih
        </option>
        {dataNamaTrainer.map((item,index)=>(
            <option value={item.nama} key={index}>
{item.nama}
            </option>
        ))}
       
    </select>
</div>
<div className={`${style.divInputan} ${style.divPembayaran}`}>
    <div>
Pembayaran
    </div>
    <input type="number" disabled={true}/>
    <select value={pembayaran} onChange={(e)=>{
        setPembayaran(e.target.value)
    }}>
        <option value="Pilih">
            Pilih
        </option>
        <option value="Cash">
         Cash
        </option>
        <option value="Non Cash">
            Non Cash
        </option>
       
    </select>
</div>
<div style={{color:keteranganKirim==="Data berhasil terkirim"?"blue":"red"}} className={style.keteranganKirim}>
{keteranganKirim}
</div>
<button onClick={()=>KlikKirim()} className={style.buttonKirim}>
Kirim
</button>


</div>

</div>
        </div>
    )
}

export default FormPersonalTrainer;